<template>
  <div>
    <PersonList/>
  </div>
</template>

<script>
import PersonList from '@/components/PersonList.vue'

export default {
  name: 'Creatives',
  components: {
    PersonList
  }
}
</script>
